import { SearchResults_LearnOpportunitiesFragment$key } from "@generated/SearchResults_LearnOpportunitiesFragment.graphql";
import { SearchResults_Query } from "@generated/SearchResults_Query.graphql";
import { SearchResults_Refetch } from "@generated/SearchResults_Refetch.graphql";
import graphql from "babel-plugin-relay/macro";
import React, { useContext, useEffect } from "react";
import { useLazyLoadQuery, usePaginationFragment } from "react-relay";
import { PrimaryButton } from "../../../infecto-lms-webapp/components/buttons/PrimaryButton";
import { SearchContext } from "../../../infecto-lms-webapp/context/search-context/SearchContextProvider";
import { NodeCard } from "../../../infecto-lms-webapp-impl/components/NodeCard.component";

const QUERY = graphql`
	query SearchResults_Query(
		$query: String
		$tagIds: [ID!]
		$orderBy: SearchLearnOpportunitiesOrderByInput
		$searchOptions: [SearchLearnOpportunitiesSearchOptionsInput!]
		$sortDirection: SearchLearnOpportunitiesSortDirectionInput
		$elementTypes: [ElementTypeV2!]
		$isCertified: Boolean
		$formatTypes: [SearchLearnOpportunitiesFormatTypeInput!]
	) {
		...SearchResults_LearnOpportunitiesFragment
			@arguments(
				query: $query
				tagIds: $tagIds
				orderBy: $orderBy
				searchOptions: $searchOptions
				sortDirection: $sortDirection
				elementTypes: $elementTypes
				isCertified: $isCertified
				formatTypes: $formatTypes
			)
	}
`;

const LEARN_OPPORTUNITIES_FRAGMENT = graphql`
	fragment SearchResults_LearnOpportunitiesFragment on Query
	@refetchable(queryName: "SearchResults_Refetch")
	@argumentDefinitions(
		first: { type: "Int", defaultValue: 20 }
		after: { type: "String" }
		query: { type: "String" }
		tagIds: { type: "[ID!]" }
		formatTypes: { type: "[SearchLearnOpportunitiesFormatTypeInput!]" }
		orderBy: { type: "SearchLearnOpportunitiesOrderByInput" }
		searchOptions: { type: "[SearchLearnOpportunitiesSearchOptionsInput!]" }
		sortDirection: { type: "SearchLearnOpportunitiesSortDirectionInput" }
		elementTypes: { type: "[ElementTypeV2!]" }
		isCertified: { type: "Boolean" }
	) {
		LearnV2 {
			SearchLearnOpportunities(
				first: $first
				after: $after
				query: $query
				tagIds: $tagIds
				orderBy: $orderBy
				searchOptions: $searchOptions
				sortDirection: $sortDirection
				elementTypes: $elementTypes
				isCertified: $isCertified
				formatTypes: $formatTypes
			) @connection(key: "SearchResults_SearchLearnOpportunities") {
				pageInfo {
					endCursor
					hasPreviousPage
					hasNextPage
					startCursor
				}
				edges {
					node {
						...NodeCard_NodeFragment
					}
				}
			}
		}
	}
`;

export function SearchResults() {
	const { filters } = useContext(SearchContext);

	const queryData = useLazyLoadQuery<SearchResults_Query>(
		QUERY,
		{ query: filters.query },
		{ fetchPolicy: "network-only" },
	);

	const { data, loadNext, refetch, hasNext } = usePaginationFragment<
		SearchResults_Refetch,
		SearchResults_LearnOpportunitiesFragment$key
	>(LEARN_OPPORTUNITIES_FRAGMENT, queryData);

	useEffect(() => {
		refetch(
			{
				...filters,
				query: filters.query ? filters.query : undefined,
			},
			{ fetchPolicy: "network-only" },
		);
	}, [filters]);

	const results =
		data.LearnV2.SearchLearnOpportunities.edges?.filter((e) => !!e?.node).map((e) => e!.node!) ||
		[];

	return (
		<div className="pb-5">
			<div className="grid ">
				{results?.map((learnOpportunity, index) => (
					<div className={`lg:col-6 col-12 `} key={index}>
						<NodeCard
							isFeatured={false}
							learnOpportunityFragmentRef={learnOpportunity}
							ignoreUserLearnState={false}
						/>
					</div>
				))}
				{results.length === 0 && (
					<div className="text-center col-12">
						Leider keine Ergebnisse - bitte passen Sie die Suchparameter an.
					</div>
				)}
			</div>
			<div className="flex justify-content-center mt-4">
				{hasNext && <PrimaryButton label="Mehr laden..." onClick={() => loadNext(10)} />}
			</div>
		</div>
	);
}
